"use strict";
import React from "react";
import classNames from "classnames";
import { IconSize } from "../types";
import * as styles from "../Icons-css";
const StylesBrushUpdate = (props) => {
  const { className, size = IconSize.Medium, color = "inherit", ...rest } = props;
  const iconClass = classNames(
    styles.icon({
      size,
      color
    }),
    "kl-icon",
    `kl-icon--${size}`,
    className
  );
  return React.createElement(
    "svg",
    { width: "24", height: "24", viewBox: "0 0 24 24", className: iconClass, ...rest },
    /* @__PURE__ */ React.createElement(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "m16.8 10.129 2.425 2.424a1 1 0 0 1 0 1.414l-1.414 1.414a1 1 0 0 1-1.414 0L8.619 7.603a1 1 0 0 1 0-1.414l1.414-1.414a1 1 0 0 1 1.414 0l2.424 2.424 3.94-4.546.354-.353A2.5 2.5 0 0 1 21.7 5.835l-.354.354zM8.62 9.017l6.364 6.364-2.939 6.465a1 1 0 0 1-1.617.293l-5.285-5.285 3.478-1.873a.75.75 0 1 0-.71-1.32l-3.876 2.086-2.173-2.174a1 1 0 0 1 .293-1.617z"
      }
    ),
    /* @__PURE__ */ React.createElement("circle", { cx: 3.5, cy: 3.5, r: 2.5, fill: "#1099FC", className: styles.accentColor })
  );
};
export default StylesBrushUpdate;
